export function ProsCons({ pros, cons }: { pros: string[]; cons: string[] }) {
  return (
    <div className="pros-cons">
      <div>
        <h4>Pros</h4>
        {pros.length ? (
          <ul>
            {pros.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        ) : (
          <p>No pros yet.</p>
        )}
      </div>
      <div>
        <h4>Cons</h4>
        {cons.length ? (
          <ul>
            {cons.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        ) : (
          <p>No cons yet.</p>
        )}
      </div>
    </div>
  );
}
